/** Same rules as backend `shared/utils/passwordPolicy.js`. */

export const PASSWORD_POLICY_MESSAGE =
  "Password must be at least 8 characters and include one uppercase letter, one lowercase letter, one number, and one special character (for example !@#$%).";

/** Short line for TextField `helperText`. */
export const PASSWORD_POLICY_HELPER_TEXT =
  "At least 8 characters, with uppercase, lowercase, a number, and a special character.";

export function passwordMeetsPolicy(raw) {
  const password = String(raw ?? "");
  if (password.length < 8) return false;
  if (!/[a-z]/.test(password)) return false;
  if (!/[A-Z]/.test(password)) return false;
  if (!/[0-9]/.test(password)) return false;
  if (!/[^A-Za-z0-9]/.test(password)) return false;
  return true;
}
